import 'react-animated-slider/build/horizontal.css';
import Slider from '../components/shared/sliders/neatSlider/Slider';
import Carousel from '../components/shared/sliders/carousel/Carousel';
import { useEffect, useState } from 'react';
import axios from '../utils/axios';
import { dateFormat } from '../utils/date';
import { usePage } from "../contexts/PageProvider";
import { HOME_URL } from '../contexts/PageProvider';
import useAuth from "../hooks/useAuth";


const ARTICLE_URL = 'article'
const transformArticleResponse = (article) => {
  
  if(article.image) {
    article.image = JSON.parse(article.image);
    // upload file component return an array 
    // each article has a singlel array
    article.image = article.image[0]; 
  }

  if(article.image_slider) {
    article.image_slider = JSON.parse(article.image_slider);
    // upload file component return an array 
    // each article has a singlel array
    article.image_slider = article.image_slider[0]; 
  }

  if(article.display) {
    article.display = article.display.split(',')
  }

  if(article?.tags?.length) {
    article.tags = article.tags.split(',')
  }

  return article;
}
export {transformArticleResponse}

const ArticleOverviewPage = () => {
  const {auth} = useAuth();
  const { pageData, setPageData } = usePage();
  if (pageData.url != HOME_URL) {
      setPageData({url: HOME_URL, title: ""});      
  }

  const [articles, setArticles] = useState(null);
  const [itemsToShow, setItemsToShow] = useState(5);
  const numberOfRecentArticlesToDisplay =  3;


  const getSliderArticles = () => {
    return articles?.filter(article => article?.display?.includes('slider')).sort(function(a,b){
      return  new Date(b.updated_at) - new Date(a.updated_at);
    });
  }

  const getArticlesOrderedByGroup = () => {
    const initialValue = {}
    const result = articles.reduce((orderedArticles, currentArticle) => {
      const currentGroup = currentArticle?.group?.order;
      const currentGroupIsActive = currentArticle?.group?.is_active;

      if (!currentGroup || !currentGroupIsActive) return orderedArticles;

      // if the key has been filtered already
      if (Object.keys(orderedArticles).includes(currentArticle?.group?.order)) return orderedArticles;

      // filter by key (group?.order)
      orderedArticles[currentGroup] = articles.filter(article => article?.group?.order === currentGroup).sort(function(a,b){
        return  new Date(b.updated_at) - new Date(a.updated_at);
      });
      return orderedArticles;
    }, initialValue);

    return Object.values(result).reverse();
  }

  const getRecentArticles = () => {
    const result = articles.sort((a,b) => {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.updated_at) - new Date(a.updated_at);
    });
    return result.slice(0, numberOfRecentArticlesToDisplay);
  }

  const getSingleArticles = () => {    
    return articles.filter(article => article?.display?.includes('single')).sort(function(a,b){
      return  new Date(b.updated_at) - new Date(a.updated_at);
    });
  }

  const getArticles = async () => {
    try {
      let config = {
        headers: {
          'Authorization': `Bearer ${auth?.accessToken}`
        }
      }
      const response = await axios.get(ARTICLE_URL, config);
      response?.data?.map(transformArticleResponse)

      setArticles(response.data.filter(article => article?.is_active));
    } catch (error) {
      // console.error(error)
    }
  }
  useEffect(() => {
    getArticles();
  }, []);
  
  const GroupWrapper = ({children}) => {
    return (<div style={{marginTop: '1.6em', width: "100%"}}>{children}</div>);
  }

  return (
    <>
        {articles && <Slider data={getSliderArticles()} />}
        {
          articles && getArticlesOrderedByGroup().map((group, idx) => {
            return <GroupWrapper key={idx}><Carousel  data={group} itemsToShow={itemsToShow} setItemsToShow={setItemsToShow} /></GroupWrapper>
          })
        }
        {articles && <GroupWrapper><Carousel data={getSingleArticles()} title='Actualités detachées' itemsToShow={itemsToShow} setItemsToShow={setItemsToShow}/></GroupWrapper>}
    </>
  );
};

export default ArticleOverviewPage;